import React from 'react';
import PropTypes from 'prop-types';
import { FieldConfig } from './HelocCalculator.utils.js';
import { commaSeparateNumber } from '../../utils/zhl-calculator.js';
import TextField from '../Fields/TextField.js';

function HelocFields(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Estimated home value",
    leftAdornment: "$",
    name: FieldConfig.homeValue.name,
    config: FieldConfig.homeValue.config,
    autoComplete: "off",
    format: commaSeparateNumber,
    required: true
  }), /*#__PURE__*/React.createElement(TextField, {
    label: "Loan balance",
    leftAdornment: "$",
    name: FieldConfig.loanBalance.name,
    config: FieldConfig.loanBalance.config,
    autoComplete: "off",
    format: commaSeparateNumber,
    required: true
  }));
}
HelocFields.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
HelocFields.defaultProps = {
  className: undefined
};

export { HelocFields as default };
